<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-radio-group v-model="activeName" @input="handleInput" size="small">
          <el-radio-button label="0">{{
            $l('INDEX.tips_all') || '全部'
          }}</el-radio-button>
          <el-radio-button label="3">{{ urgent }}</el-radio-button>
          <el-radio-button label="2">{{ focus }}</el-radio-button>
          <el-radio-button label="1">{{ stablize }}</el-radio-button>
        </el-radio-group>

        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openChooseAmzSku"
          v-if="allow('A')"
        >
          {{ $l('btn_add_focus_sku') || '添加重点关注产品' }}
        </b-button>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseAmzSku
      :visible="chooseAmzSkuOption.visible"
      :multiple="chooseAmzSkuOption.multiple"
      :confirmOnClose="chooseAmzSkuOption.confirmOnClose"
      @confirm="confirm"
      @close="close"
    ></ChooseAmzSku>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import ChooseAmzSku from '../choose-amz-sku'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, ChooseAmzSku },
  data() {
    return {
      usePage: true,
      activeName: '0',
      tmpForm: {},
      chooseAmzSkuOption: {
        visible: false,
        multiple: false,
        confirmOnClose: true,
      },
      levelGroupData: [],
    }
  },
  mounted() {
    this.getLevelGroup({})
  },
  computed: {
    stablize() {
      let stablizeNumber = this.levelGroupData
        .filter((e) => e.label == '1')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_stablize') || '稳定') +
        ` (${stablizeNumber ? stablizeNumber : 0})`
      )
    },
    focus() {
      let focusNumber = this.levelGroupData
        .filter((e) => e.label == '2')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_focus') || '关注') +
        ` (${focusNumber ? focusNumber : 0})`
      )
    },
    urgent() {
      let urgentNumber = this.levelGroupData
        .filter((e) => e.label == '3')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_urgent') || '紧急') +
        ` (${urgentNumber ? urgentNumber : 0})`
      )
    },
  },
  methods: {
    getLevelGroup(form) {
      this.$api
        .ecomAmzListingFtySkuMonitorLevelGroupApi({ ...form })
        .then((res) => {
          this.levelGroupData = res?.body?.data || []
        })
    },
    getData(form) {
      this.loading = true
      if (this.activeName > 0 && this.activeName != '0') {
        form.skuAlertLevel = this.activeName
      } else {
        form.skuAlertLevel = '0'
      }
      this.$api
        .ecomAmzListingFtySkuMonitorListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          const tmpData = res.body.data || []
          const pageSize = res.body.pageSize
          const curPage = res.body.curPage
          let start = (curPage - 1) * pageSize
          const tableData = []
          for (let i = 0; i < tmpData.length; i++) {
            const orderInfo = tmpData[i]
            orderInfo.seq = start + i + 1
            const fbaInvMonitorList = orderInfo.fbaInvMonitorList || [
              { ...orderInfo },
            ]
            let amzFtySkuInvMonitorCode = ''

            fbaInvMonitorList.map((e) => {
              if (
                amzFtySkuInvMonitorCode != orderInfo.amzFtySkuInvMonitorCode
              ) {
                amzFtySkuInvMonitorCode = orderInfo.amzFtySkuInvMonitorCode
                orderInfo['rowspan'] = fbaInvMonitorList.length
              } else {
                orderInfo['rowspan'] = 0
              }
              tableData.push({ ...e, ...orderInfo })
            })
          }
          res.body.data = tableData
          this.setData(res)
          this.setData(res)
          this.tmpForm = form
          this.getLevelGroup(form)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    openChooseAmzSku() {
      this.chooseAmzSkuOption.visible = true
    },
    close() {
      this.chooseAmzSkuOption.visible = false
    },
    confirm({ amzSkuCode }) {
      const skuCodes = [amzSkuCode]
      this.loadingOpen()
      this.$api
        .ecomAmzListingFtySkuMonitorAddApi({
          skuCodes,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData(this.tmpForm)
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    handleInput() {
      this.page.curPage = 1
      this.getData(this.tmpForm)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0 !important;
}
::v-deep .is-active {
  color: #409eff !important;
}
</style>
